/* Rescuevation - Lastenroboter (Familie rob)

   1. Einmal-Folgen: [data-rob-live] bekommt beim ersten Sichtkontakt .is-live.
      Der Ruhezustand ohne Klasse ist das fertige Bild (additive Bewegung):
      ohne JS, ohne IntersectionObserver oder mit prefers-reduced-motion bleibt
      alles sichtbar und vollstaendig.
   2. Loops ([data-rob-loop]) pausieren ausserhalb des Viewports.
   3. Zaehler: [data-rob-zaehl] zaehlt einmal hoch, der Endwert steht im DOM.
   4. Aufbau: [data-rob-konfig] tauscht Module in der Szene (Baukasten und
      Lagenwahl), schreibt die Auswahl ins Formularfeld contact[Aufbau-Wunsch].
   5. Sprung zum Formular: das Formular blitzt einmal auf, das Anliegen ist
      vorgewaehlt (rescu-rob-anfrage setzt die Vorwahl selbst). */
(function () {
  if (window.__robFamilie) return;
  window.__robFamilie = true;

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var PLAETZE = [146, 266, 386];
  var PLATZ_Y = 222;

  /* ---------------------------------------------------------------- 3 */
  function zaehle(wurzel) {
    if (ruhig) return;
    wurzel.querySelectorAll('[data-rob-zaehl]').forEach(function (f) {
      if (f.__robGezaehlt) return;
      f.__robGezaehlt = true;
      var ende = f.textContent.trim();
      var m = ende.match(/^(\d{1,4})(?:,(\d))?(.*)$/);
      if (!m) return;
      var ziel = parseFloat(m[1] + (m[2] ? '.' + m[2] : ''));
      var nk = m[2] ? 1 : 0;
      var rest = m[3] || '';
      if (ziel < 2) return;
      f.setAttribute('aria-label', ende);
      var t0 = null;
      var dauer = 1300;
      function schritt(t) {
        if (!t0) t0 = t;
        var x = Math.min(1, (t - t0) / dauer);
        var k = 1 - Math.pow(1 - x, 4);
        f.textContent = (ziel * k).toLocaleString('de-DE', { minimumFractionDigits: nk, maximumFractionDigits: nk }) + rest;
        if (x < 1) requestAnimationFrame(schritt);
        else { f.textContent = ende; f.removeAttribute('aria-label'); }
      }
      requestAnimationFrame(schritt);
    });
  }

  /* ---------------------------------------------------------------- 4 */
  function neuAnimieren(el) {
    if (ruhig || !el) return;
    el.classList.remove('is-neu');
    void el.getBoundingClientRect();
    el.classList.add('is-neu');
  }

  function setzeAufbau(szene, liste, neu) {
    var gruppen = szene.querySelectorAll('[data-rob-svg-modul]');
    gruppen.forEach(function (g) {
      var name = g.getAttribute('data-rob-svg-modul');
      var i = liste.indexOf(name);
      if (i < 0) {
        g.classList.add('rob-modul--aus');
        return;
      }
      g.classList.remove('rob-modul--aus');
      g.setAttribute('transform', 'translate(' + PLAETZE[i] + ' ' + PLATZ_Y + ')');
      g.style.transform = 'translate(' + PLAETZE[i] + 'px, ' + PLATZ_Y + 'px)';
      g.style.setProperty('--i', i);
      if (neu === 'alle' || neu === name) neuAnimieren(g.querySelector('.rob-szene__modul-innen'));
    });
    szene.querySelectorAll('.rob-szene__punkt').forEach(function (p) {
      var platz = parseInt(p.getAttribute('data-rob-platz'), 10);
      var war = p.classList.contains('is-belegt');
      var ist = platz < liste.length;
      p.classList.toggle('is-belegt', ist);
      if (ist && (!war || neu === 'alle')) neuAnimieren(p);
    });
  }

  function namenVon(szene, liste) {
    return liste.map(function (n) {
      var g = szene.querySelector('[data-rob-svg-modul="' + n + '"]');
      return g ? g.getAttribute('data-rob-name') : n;
    });
  }

  function insFormular(text) {
    document.querySelectorAll('[data-rob-aufbau-feld]').forEach(function (f) { f.value = text; });
    document.querySelectorAll('[data-rob-aufbau-anzeige]').forEach(function (a) {
      var t = a.querySelector('[data-rob-aufbau-text]');
      if (t) t.textContent = text;
      a.hidden = false;
    });
  }

  function konfig(wurzel) {
    var szene = wurzel.querySelector('[data-rob-szene]');
    if (!szene) return;
    var max = parseInt(wurzel.getAttribute('data-rob-max') || '3', 10);
    var liste = (szene.getAttribute('data-rob-start') || '').split(',').filter(Boolean);
    var modulBtns = wurzel.querySelectorAll('[data-rob-modul]');
    var lageBtns = wurzel.querySelectorAll('[data-rob-lage]');
    var summe = wurzel.querySelector('[data-rob-summe]');
    var meldung = wurzel.querySelector('[data-rob-meldung]');
    var belegt = wurzel.querySelector('[data-rob-belegt]');
    var lageText = wurzel.querySelector('[data-rob-lage-text]');
    var buehne = wurzel.querySelector('[data-rob-buehne-konfig]') || szene;
    var angefasst = false;

    function zeige(neu) {
      if (neu) szene.classList.add('rob-szene--bedient');
      setzeAufbau(szene, liste, neu);
      var namen = namenVon(szene, liste);
      if (summe) summe.textContent = namen.length ? namen.join(', ') : 'Noch kein Modul gewählt';
      if (belegt) {
        belegt.textContent = liste.length + ' von ' + max + ' Plätzen belegt';
        belegt.setAttribute('data-voll', liste.length >= max ? 'true' : 'false');
      }
      wurzel.querySelectorAll('[data-rob-platz-anzeige]').forEach(function (s, i) {
        s.classList.toggle('is-belegt', i < liste.length);
      });
      modulBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', liste.indexOf(b.getAttribute('data-rob-modul')) >= 0 ? 'true' : 'false');
      });
      if (angefasst) insFormular(namen.join(', ') || 'noch offen');
    }

    modulBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        angefasst = true;
        var n = b.getAttribute('data-rob-modul');
        var i = liste.indexOf(n);
        if (meldung) meldung.textContent = '';
        if (i >= 0) {
          liste.splice(i, 1);
          zeige('');
          lageBtns.forEach(function (l) { l.setAttribute('aria-pressed', 'false'); });
          return;
        }
        if (liste.length >= max) {
          if (meldung) meldung.textContent = 'Die Ladefläche ist voll. Nimm zuerst ein Modul herunter.';
          buehne.classList.remove('is-voll');
          void buehne.getBoundingClientRect();
          if (!ruhig) buehne.classList.add('is-voll');
          return;
        }
        liste.push(n);
        zeige(n);
        lageBtns.forEach(function (l) { l.setAttribute('aria-pressed', 'false'); });
      });
    });

    lageBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        angefasst = wurzel.hasAttribute('data-rob-formular');
        liste = (b.getAttribute('data-rob-lage') || '').split(',').filter(Boolean).slice(0, max);
        lageBtns.forEach(function (l) { l.setAttribute('aria-pressed', l === b ? 'true' : 'false'); });
        if (lageText && b.getAttribute('data-rob-text')) lageText.textContent = b.getAttribute('data-rob-text');
        if (meldung) meldung.textContent = '';
        zeige('alle');
      });
    });

    wurzel.querySelectorAll('[data-rob-aufbau-senden]').forEach(function (a) {
      a.addEventListener('click', function () {
        angefasst = true;
        insFormular(namenVon(szene, liste).join(', ') || 'noch offen');
      });
    });

    zeige('');
  }

  /* ---------------------------------------------------------------- 5 */
  function zielBlitz() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#ContactForm"]');
      if (!a || ruhig) return;
      var karte = document.querySelector('#ContactForm .rob-anfrage__formular');
      if (!karte) return;
      setTimeout(function () {
        karte.classList.remove('is-ziel');
        void karte.getBoundingClientRect();
        karte.classList.add('is-ziel');
      }, 450);
    });
  }

  /* ---------------------------------------------------------------- 1 + 2 */
  function start() {
    document.querySelectorAll('[data-rob-konfig]').forEach(konfig);
    zielBlitz();

    var live = document.querySelectorAll('[data-rob-live]');
    if (!hatIO || ruhig) return;

    var einmal = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-live');
        zaehle(e.target);
        einmal.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    live.forEach(function (el) { einmal.observe(el); });

    var sicht = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('rob-pausiert', !e.isIntersecting); });
    }, { threshold: 0 });
    document.querySelectorAll('[data-rob-loop]').forEach(function (el) { sicht.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
